import { createStore } from 'vuex'

export const store = createStore({
    state() {
        return {
            caseTitle_number: "",
            accusedName_accusations: "",
            selectedGovernorates: [],
            selectedAuthorities: [],
            referralYear: "",
            rtl: localStorage.getItem('lang') == 'ar'
        }
    },
}) 